import './input.css'
const InputJim = (props) => {

  const { type, name, value, label, placeholder, classN, error, onChange, onBlur } = props;

  const handleChange = (e) => {
    const { name, value } = e.target
    onChange(name, value)
  }
  const handleBlur = (e) => {
    const { name, value } = e.target
    onBlur(name, value)
  }
  
  return (
    <>
      <div className={`input-container ${classN}`}>

      <label className='label'>
          {label}
        </label>
        <input
          name={name}
          type={type}
          className={error ? 'text-input errorfocus' : 'text-input'}
          autoComplete='off'
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          required
        />

        <label className='error'>
          {error}
        </label>
      </div>

    </>
  )
}
export default InputJim